export const ENABLE_CROSS_CHAIN_NETWORK_IDS = Object.freeze(
  (process.env.VUE_APP_ENABLE_CROSS_CHAIN_NETWORK_IDS?.split(',') ?? []).filter(
    chainId => !!chainId,
  ),
);
